jQuery(function () {
    // IMPORTANT: This event listener must be registered _before_ [data-method] as
    // [data-method] will execute the potentially destructive action we're asking
    // about here.
    $('[data-confirm]').on('click', function (evt) {
        var message = $(evt.target).attr('data-confirm');
        if (confirm(message)) {
            return true;
        }
        else {
            evt.stopImmediatePropagation();
            evt.preventDefault();
            return false;
        }
    });
    $('a[data-method]').on('click', function (evt) {
        evt.preventDefault();
        var $target = $(evt.target);
        $.ajax({
            url: $target.attr('href'),
            method: $target.attr('data-method')
        }).done(function (response) { return handleAjaxResponse(response); }).fail(function (response) { return handleAjaxFailure(response); });
        function handleAjaxResponse(response) {
            if (response.message) {
                alert(response.message);
            }
            if (response.redirect) {
                document.location.href = response.redirect;
            }
        }
        function handleAjaxFailure(response) {
            alert("Hoppsan! N\u00E5got gick fel n\u00E4r vi f\u00F6rs\u00F6kte g\u00F6ra detta. (" + response.status + ")");
        }
    });
});
